import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {Group} from '@pb/kit-component-group';
import '@pb/kit-styles-global';

import {CompanyDetailView, CompanySearchView} from '/src/modules/company-search';
import {EventDetailsView} from '/src/modules/event-details';
import {HolidaySearchView} from '/src/modules/holiday';
import {ManageEventCalendarView as RealManageEventCalendarView} from '/src/modules/manage-event-calendar';
import {
    CompanyListView,
    CompanyManagementView,
    PushCompaniesView,
    RnaMappingView,
} from '/src/modules/placeholder';
import {SideNav} from '/src/modules/side-nav';
import {AppStateProvider} from '/src/store';

import {useInitSidebarLinks} from '../modules/sidebar-init/useSidebarLinks';

import {appLayout, contentArea} from '../modules/side-nav/side-nav.styles.module.styl';


const ExposedComponent = () => {
    useInitSidebarLinks();
    return (
        <AppStateProvider>
            <Group style={{padding: '16px', height: '99%', width: '100%', boxSizing: 'border-box'}}>
                <div className={appLayout}>
                    <SideNav/>
                    <div className={contentArea}>
                        <Routes>
                            {/* Default route - redirect to company-search */}
                            <Route
                                index={true}
                                element={<Navigate to="company-search" replace={true}/>}
                            />
                            {/* CCDB Company Search routes */}
                            <Route
                                path="company-search"
                                element={<CompanySearchView/>}
                            />
                            <Route
                                path="company-detail/:companyId"
                                element={<CompanyDetailView/>}
                            />
                            {/* Navigation menu routes */}
                            <Route path="company-management" element={<CompanyManagementView/>}/>
                            <Route path="rna-mapping" element={<RnaMappingView/>}/>
                            <Route path="company-list" element={<CompanyListView/>}/>
                            <Route path="holiday" element={<HolidaySearchView/>}/>
                            <Route path="push-companies" element={<PushCompaniesView/>}/>
                            <Route path="event-details" element={<EventDetailsView/>}/>
                            <Route path="manage-event-calendar" element={<RealManageEventCalendarView/>}/>
                        </Routes>
                    </div>
                </div>
            </Group>
        </AppStateProvider>
    );
};

export default ExposedComponent;
